import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getHierarchies } from "api";
import { lookupsUpserted } from "reducers/lookupsSlice";

export const fetchDivisions = createAsyncThunk(
	"division/fetchDivisions",
	async (_, { dispatch, rejectWithValue }) => {
		try {
			//code = parent division containing RCs we want

			const data = await getHierarchies({
				code: "WTPRVDR", //hard coded to be the providedr arm
				domain: "Test", //org hierarchy
				viewOption: "Immediate", //show immediate children of the node
			});

			const lookups = data
				.sort((a, b) => (a < b ? 1 : a > b ? -1 : 0))
				.map((d) => ({
					domainCode: "divisions",
					id: d.code,
					code: d.code,
					description: d.name,
				}));

			dispatch(lookupsUpserted(lookups));
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const initialState = {
	status: "idle",
	error: null,
};

const divisionSlice = createSlice({
	name: "division",
	initialState,
	extraReducers: {
		[fetchDivisions.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchDivisions.fulfilled]: (state, action) => {
			state.status = "idle";
		},
		[fetchDivisions.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

export default divisionSlice.reducer;
